import request from './request'
import type { ApiResponse } from './request'
import type { LoginForm, LoginResult, RegisterTenantForm, RegisterTenantResult, UserInfo } from '@/types/api'

// 登录（tenantId 用于多企业归属时指定企业）
export const login = (data: LoginForm): Promise<ApiResponse<LoginResult>> => {
  return request.post('/auth/login', data).then(res => res.data)
}

// 企业注册开通（SaaS 公开接口；2026-10-08 起凭邀请码注册，短信验证暂时关闭）
export const registerTenant = (data: RegisterTenantForm & { inviteCode: string }): Promise<ApiResponse<RegisterTenantResult>> => {
  return request.post('/saas/register', data).then(res => res.data)
}

// 获取用户信息
export const getUserInfo = (): Promise<ApiResponse<UserInfo>> => {
  return request.get('/auth/me').then(res => res.data)
}

// 刷新Token
export const refreshToken = (refreshToken: string): Promise<ApiResponse<{ token: string }>> => {
  return request.post('/auth/refresh', { refreshToken }).then(res => res.data)
}

// 获取服务器时间（北京时间），开单等场景的"当前日期"以此为准，防止修改本地时间绕过
export const getServerTime = (): Promise<ApiResponse<{ timestamp: number; date: string; dateTime: string }>> => {
  return request.get('/settings/server-time').then(res => res.data)
}
